import { Factory } from 'fishery'
import { OpalApiResponseDocument } from '@opallabs/api'
import { linkageFromResource } from '@opallabs/json-api'
import { Workflows } from '../../../Workflow'
import { workflowContextResourceFactory } from '../resource_objects/workflow_context'

type ReadWorkflowsResponseV2 = OpalApiResponseDocument<'ReadWorkflowsV2', 200>

type ReadMomentWorkflowsTransientParams = {
  legacyMomentIds: number[]
  version: string
}

/**
 * One workflow per moment, with the id `workflow-<legacy moment id>-<version>`
 * and a context `context-<legacy moment id>`.
 */
export const readMomentWorkflowsFactory: Factory<
  ReadWorkflowsResponseV2,
  ReadMomentWorkflowsTransientParams
> = Factory.define<ReadWorkflowsResponseV2, ReadMomentWorkflowsTransientParams>(
  ({ transientParams: { legacyMomentIds = [], version = 'v1' } }) => {
    const contexts = legacyMomentIds.map((legacyMomentId) =>
      workflowContextResourceFactory.build({
        id: `context-${legacyMomentId}`,
        relationships: {
          moment: { data: { id: `${legacyMomentId}`, type: 'moment' } },
        },
      })
    )
    // `Workflows.V2` lets its default id win over an override, so set the id
    // after building
    const workflows = contexts.map((context, index) => {
      const workflow = Workflows.V2()
      return {
        ...workflow,
        id: `workflow-${legacyMomentIds[index]}-${version}`,
        relationships: {
          ...workflow.relationships,
          context: linkageFromResource(context),
        },
      }
    })

    return {
      data: workflows,
      included: contexts,
      meta: {
        resource_type: 'workflow',
        total: workflows.length,
        page: { limit: 250, offset: 0 },
      },
    } satisfies ReadWorkflowsResponseV2
  }
)
